<template>
  <div class="detailsBox">
    <span class="details_title">{{ detailMsg.title }}</span>
    <span class="details_time">{{ detailMsg.addTimeStr }}</span>
    <div class="content_text">
      <div class="content" v-html="detailMsg.content"></div>
    </div>
    <div class="botBtn">
      <div class="btn" @click="closeDetail">关闭</div>
      <div class="btn" @click="toGame(detailMsg.pcUrl)">进入游戏</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "detail",
  props: ["detailMsg"],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    closeDetail() {
      this.$store.dispatch("IsShowDetailFun", false);
    },
    toGame(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.detailsBox {
  @include flex_box(column, space-between, stretch);
  width: 6.8rem;
  height: 80%;
  padding: 0.4rem 0.3rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
  font-size: 12px;
  background-color: #fff;
  border-radius: 4px;
  .details_title {
    font-size: 16px;
    font-weight: bold;
  }
  .details_time {
    font-size: 12px;
    margin-top: 0.1rem;
  }
  .content_text {
    flex: 1;
    @include flex_box(column, none, stretch);
    text-align: left;
    line-height: 26px;
    overflow-y: scroll;
  }
  .content {
    flex: 1;
    color: #333 !important;
  }
  .botBtn,
  .btn {
    @include flex_box(row, center, center);
  }
  .botBtn {
    margin-top: 0.3rem;
  }
  .btn {
    width: 2.2rem;
    height: 0.6rem;
    background-color: #ff913a;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    margin: 0 0.6rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/detail.vue